import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const autotask = defineConnector({
  identifier: "autotask",
  name: "Autotask",
  tagLine: "IT service management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.autotask\\.net/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "apiintegrationcode",
        value: app.config.apiIntegrationCode,
      },
      { name: "username", value: app.config.username },
      { name: "secret", value: app.secret.apiKey },
    ]),
  steps: [
    {
      title: "Find your Autotask API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Autotask API authentication docs](https://ww4.autotask.net/help/DeveloperHelp/Content/APIs/General/API_Authentication.htm) and create API integration credentials in Autotask. Copy the username, secret, and the Autotask subdomain for your account.",
        },
      ],
    },
    {
      title: "Connect your Autotask account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Autotask instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Autotask API Zone",
          placeholder: "webservices3",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The zone subdomain for your Autotask instance (e.g., webservices3, webservices1, etc.)",
        },
        {
          kind: "input",
          label: "API Integration Code",
          placeholder: "ASHJKLFDKAHKASLFH85LSA905H",
          required: true,
          target: { kind: "configuration", field: "apiIntegrationCode" },
          helperText:
            "The tracking identifier assigned to your API-only user (27-character string)",
        },
        {
          kind: "input",
          label: "API Username",
          placeholder: "apiuser@example.com",
          required: true,
          target: { kind: "configuration", field: "username" },
          helperText: "The email address of your API-only user account",
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The secret for your API-only user account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.autotask.net/atservicesrest/v1.0/Companies/entityinformation`,
  },
  publicEnvVars: ({ subdomain }) => ({
    AUTOTASK_URL: subdomain ? `https://${subdomain}.autotask.net` : "",
  }),
});
